import { Box } from "@mui/system";
import { extractNameFromEmail, getAvatarColor, getAvatarInitials } from "../../utils/utils";
import { Avatar, Tooltip, Typography } from "@mui/material";

interface UserAvatarProps {
    user: {
      email: string;
      name?: string;
      pictureUrl?: string;
      avatar_url?: string;
      picture?: string;
      profileOrgRelationshipId?: string;
    } | null;
    size?: number;
    showName?: boolean;
    maxNameWidth?: number;
  }
  
  const UserAvatar: React.FC<UserAvatarProps> = ({ 
    user, 
    size = 28, 
    showName = false,
    maxNameWidth = 50 
  }) => {
    if (!user) return null;
  
    const avatarSrc = user.pictureUrl || user.avatar_url || user.picture || undefined;
    const displayName = user.name || extractNameFromEmail("", user.email);
  
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Tooltip title={displayName} placement="top" arrow>
          <Avatar
            src={avatarSrc}
            alt={displayName}
            sx={{
              width: size,
              height: size,
              bgcolor: !avatarSrc && user.email ? getAvatarColor(user.email || user.name) : undefined,
              fontSize: size / 2.5,
            }}
          >
            {!avatarSrc && user.email ? getAvatarInitials(user.email || user.name) : null}
          </Avatar>
        </Tooltip>
        {showName && (
          <Tooltip title={displayName} placement="top" arrow>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 400,
                maxWidth: maxNameWidth,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {displayName}
            </Typography>
          </Tooltip>
        )}
      </Box>
    );
  };

  export default UserAvatar